import React from "react";
import {
  Layout,
  Form,
  Input,
  Button,
  Row,
  Col,
  Card,
  Typography,
  message,
} from "antd";
import {
  MailOutlined,
  PhoneOutlined,
  EnvironmentOutlined,
} from "@ant-design/icons";
import LandingFooter from "../components/layout/Footer";
import LandingHeader from "../components/layout/Header";
import contactIllustration from "../assets/images/contact-img.png"; // Add an illustration
import Post from "../services/Post";

const { Content } = Layout;
const { Title, Text } = Typography;

const ContactUs = () => {
  const [form] = Form.useForm();

  const onFinish = async (values) => {
    try {
      const res = await Post.SendInquiry(values);
      console.log(res);

      if (res.error) {
        message.error(res.error);
        return;
      }
      message.success(res.data);
      form.resetFields(); // Reset form after successful submission
    } catch (error) {
      message.error("Something went wrong. Please try again.");
    }
  };

  return (
    <Layout>
      <LandingHeader />
      <Content style={{ padding: "50px", minHeight: "80vh" }}>
        <Row justify="center" className="mb-4" align="middle">
          <Title>Contact Us</Title>
        </Row>
        <Row justify="center" gutter={[32, 32]} align="middle">
          <Col xs={24} sm={12} md={14} lg={12} xl={10}>
            <Card
              title={<Title level={3}>Get in Touch</Title>}
              bordered={false}
              style={{
                borderRadius: "10px",
                boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
                background: "#ffffff",
              }}
            >
              <Form layout="vertical" form={form} onFinish={onFinish}>
                <Form.Item
                  label={<Text strong>Name</Text>}
                  name="name"
                  rules={[
                    { required: true, message: "Please enter your name!" },
                  ]}
                >
                  <Input placeholder="Enter your name" />
                </Form.Item>

                <Form.Item
                  label={<Text strong>Email</Text>}
                  name="email"
                  rules={[
                    {
                      required: true,
                      type: "email",
                      message: "Please enter a valid email!",
                    },
                  ]}
                >
                  <Input placeholder="Enter your email" />
                </Form.Item>

                <Form.Item
                  label={<Text strong>Subject</Text>}
                  name="subject"
                  rules={[
                    { required: true, message: "Please enter the subject!" },
                  ]}
                >
                  <Input placeholder="Enter the subject" />
                </Form.Item>

                <Form.Item
                  label={<Text strong>Message</Text>}
                  name="message"
                  rules={[
                    { required: true, message: "Please enter your message!" },
                  ]}
                >
                  <Input.TextArea rows={4} placeholder="Enter your message" />
                </Form.Item>

                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    block
                    className="form-btn"
                  >
                    Send Message
                  </Button>
                </Form.Item>
              </Form>
            </Card>
          </Col>
          <Col xs={24} sm={12} md={10} lg={8} xl={6}>
            <img
              src={contactIllustration}
              alt="Contact Us"
              style={{ width: "100%" }}
            />
          </Col>
        </Row>
        <Row justify="center" style={{ marginTop: "30px" }}>
          <Col xs={24} sm={18} md={14} lg={10} xl={8}>
            <Card
              bordered={false}
              style={{
                borderRadius: "10px",
                textAlign: "center",
                boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
                background: "#ffffff",
              }}
            >
              <Title level={4}>Contact Information</Title>
              <p>
                <MailOutlined
                  style={{ color: "#a6cc43", marginRight: "8px" }}
                />
                rebatedekho.services@gmail.com
              </p>
              <p>
                <PhoneOutlined
                  style={{ color: "#a6cc43", marginRight: "8px" }}
                />
                +91-7240700044
              </p>
              <p>
                <EnvironmentOutlined
                  style={{ color: "#a6cc43", marginRight: "8px" }}
                />
                SA-312, Urbana Jewels, Muhana Mandi, Jaipur, India, 302029
              </p>
            </Card>
          </Col>
        </Row>
      </Content>
      <LandingFooter />
    </Layout>
  );
};

export default ContactUs;
